import React, { useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import CommonGrid from "../../../../components/CommonCompo/CommonGrid/CommonGrid";
import { usePlanning } from "../../../../Hooks/Features/Pocker/usePlanning";
import { Dropdown } from "primereact/dropdown";
import { timeOptions } from "../../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../../../Hooks/Common/useCommon";
import PanelHeaderTemplate from "../../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { Dialog } from "primereact/dialog";
import CommonFilterDropdown from "../../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
import TaskDetailsPopup from "../../../../components/TaskList/TaskDetailsPopup";

function Planning() {

  const { columns, rowData, option, setOption, selectedHour, setSelectedHour, getPlanningDetails, handleSendToEstimate, tagRef, loader, handleData, projectWiseData, totalData, showPopup, setShowPopup, upsertBucketplanning, selectedRows, showInfo, setCommonFilter, commonFilter, expanded, setExpanded, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup } = usePlanning();
  const { checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  return (
    <div ref={() => checkPermission("Planning", tagRef)}>
      <div ref={tagRef} id='{"tabname": "bucket_planning", "data": "agileplanning_bucket_planning_tab"}' >
        <div className="d-flex justify-content-between align-items-center my-3 px-3 gap-3">
          <div className="d-flex gap-3 align-items-center flex-grow-1">
            <h5 className="mb-0">Planning</h5>
            <div className="sk-segment-control" style={{ maxWidth: "220px" }}>
              <button
                type="button"
                className={`sk-segment-btn ${commonFilter.taskType ? 'active' : ''}`}
                onClick={() => { setCommonFilter({ ...commonFilter, taskType: true, isChange: true }); setOption((prev) => ({ ...prev, apiCall: true })); }}
              >
                Agile Flow
              </button>
              <button
                type="button"
                className={`sk-segment-btn ${!commonFilter.taskType ? 'active' : ''}`}
                onClick={() => { setCommonFilter({ ...commonFilter, taskType: false, isChange: true }); setOption((prev) => ({ ...prev, apiCall: true })); }}
              >
                Direct
              </button>
            </div>
            <div style={{ width: "150px" }}>
              <input type="text" className="input-dd w100 mb-0" placeholder="Issue key..."
                value={commonFilter.issueKey}
                onChange={(e) => { setCommonFilter({ ...commonFilter, issueKey: e.target?.value, isChange: true }); }}
                onBlur={() => { if (commonFilter?.isChange) { getPlanningDetails(); } }} />
            </div>
            {commonFilter?.totalTasks !== undefined && (
              <span className="fw-semibold text-muted">{commonFilter.totalTasks} Tasks</span>
            )}
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button
              data-icon-only="true"
              data-action-type="default"
              onClick={() => getPlanningDetails()}
              title="Refresh"
            >
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <button
              data-icon-only="true"
              data-action-type="default"
              onClick={() => setShowFiltersDrawer(true)}
              title="Filters"
            >
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
            {
              expanded ? (
                <button title="Collapse All" data-icon-only="true" data-action-type="default" onClick={() => setExpanded(false)}>
                  <FontAwesomeIcon icon="fa-solid fa-list" />
                </button>
              ) : (
                <button title="Expand All" data-icon-only="true" data-action-type="default" onClick={() => setExpanded(true)}>
                  <FontAwesomeIcon icon="fa-solid fa-expand" />
                </button>
              )
            }

            {
              commonFilter.taskType && <>
                <button title="Bulk estimate" data-icon-only="true" data-action-type="default" onClick={() => {
                  if (selectedRows?.filter(id => id !== "all")?.length <= 0) {
                    showInfo("info", "Please select an issue");
                    return
                  }
                  setShowPopup({ show: true })
                }}><FontAwesomeIcon icon="fa-solid fa-bars-progress" /></button>
                <div style={{ width: "100px" }}>
                  <Dropdown
                    value={selectedHour}
                    onChange={(e) => { setSelectedHour(e.target.value); }}
                    placeholder="Hours"
                    options={timeOptions}
                    optionLabel="label"
                    filter
                    filterInputAutoFocus
                    className="input-dd mb-0 w100"
                  />
                </div>
              </>
            }
            <button
              className="sk-btn sk-btn-primary rounded" value="submit" onClick={handleSendToEstimate} title={commonFilter.taskType ? "Send to Estimate" : "Declare"}>
              <FontAwesomeIcon icon="fa-solid fa-paper-plane" />{" "}
              {commonFilter.taskType ? "Send to Estimate" : "Declare"}
            </button>
          </div>
        </div>

        <div className="mt-2" style={{ height: "calc(100vh - 100px)", overflowY: "auto", }}>
          <CommonGrid columns={columns} data={rowData} loader={loader} expandAll={expanded} rowHeight={30} headerHeight={50} />
        </div>
      </div>

      <Dialog
        className="modal-xsmall"
        visible={showPopup?.show}
        draggable={false}
        header={() => <div>Bulk Estimate</div>}
        onHide={() => { setShowPopup({ show: false }); }}>
        <div>
          <div className="notes my-2">
            Bulk estimates of complexity and Longitivity cannot be filled together.
          </div>
          <div>
            <div>
              <label>Complexity</label>
              <Dropdown
                className="input-dd"
                filter
                showClear
                value={showPopup?.complexity_id}
                style={{ width: "100%" }}
                placeholder="Complexity"
                options={option?.complexity}
                optionLabel="issue_complexity_name"
                optionValue="issue_complexity_id"
                disabled={showPopup?.longitivity_id}
                onChange={(e) => setShowPopup((prev) => ({ ...prev, complexity_id: e.value, longitivity_id: '', }))}
              />
            </div>
            <div>
              <label>Longitivity</label>
              <Dropdown
                className="input-dd"
                filter
                showClear
                value={showPopup?.longitivity_id}
                style={{ width: "100%" }}
                placeholder="Longitivity "
                options={option?.logitivity}
                optionLabel="issue_logitivity_name"
                optionValue="issue_logitivity_id"
                disabled={showPopup?.complexity_id}
                onChange={(e) => setShowPopup((prev) => ({ ...prev, longitivity_id: e.value, complexity_id: '' }))}
              />
            </div>
            <div>
              <label>Estimate</label>
              <Dropdown
                className="input-dd"
                filter
                showClear
                value={showPopup?.estimate_seconds}
                style={{ width: "100%" }}
                placeholder="Estimate "
                options={option?.estimate}
                optionLabel="label"
                optionValue="bid_seconds"
                onChange={(e) => setShowPopup((prev) => ({ ...prev, estimate_seconds: e.value }))}
              />
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-end my-2">
            <button className="button btn-primary" onClick={() => upsertBucketplanning(null, null, "bulk")}>
              Submit
            </button>
          </div>
        </div>
      </Dialog>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
          <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
              <div className="sk-drawer-header">
                  <h5 className="sk-drawer-title">Filters</h5>
                  <div className="d-flex align-items-center gap-2">
                      <button className="sk-drawer-clear-btn" onClick={() => {
                          setCommonFilter({
                              projects: [],
                              sprint: [],
                              issueType: [],
                              subProject: [],
                              reporters: [],
                              issueKey: "",
                              taskType: true,
                              isChange: true
                          });
                          setOption((prev) => ({ ...prev, apiCall: true }));
                      }}>Clear All</button>
                      <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                          <FontAwesomeIcon icon="fa-solid fa-xmark" />
                      </button>
                  </div>
              </div>
              <div className="sk-drawer-body">
                  <div className='d-flex flex-column gap-4'>
                      {/* Flow Type Filter */}
                      <div className="sk-drawer-filter-group">
                          <div className="task-list-filter-label">Flow Type</div>
                          <div className="sk-segment-control mb-3">
                              <button type="button" className={`sk-segment-btn ${commonFilter.taskType ? 'active' : ''}`} onClick={() => { setCommonFilter({ ...commonFilter, taskType: true, isChange: true }); setOption((prev) => ({ ...prev, apiCall: true })); }}>Agile Flow</button>
                              <button type="button" className={`sk-segment-btn ${!commonFilter.taskType ? 'active' : ''}`} onClick={() => { setCommonFilter({ ...commonFilter, taskType: false, isChange: true }); setOption((prev) => ({ ...prev, apiCall: true })); }}>Direct</button>
                          </div>
                      </div>

                      {/* Dimensions Filter */}
                      <div className="sk-drawer-filter-group">
                          <div className="task-list-filter-label">Dimensions</div>
                          <div className="d-flex flex-column gap-2">
                              <MultiSelect
                                  options={option?.projects}
                                  optionLabel="project_name"
                                  optionValue="project_id"
                                  placeholder="Project"
                                  value={commonFilter?.projects}
                                  filter
                                  onChange={(e) => { setCommonFilter({ ...commonFilter, projects: e.value || [], isChange: true }); }}
                                  onHide={() => { if (commonFilter?.isChange) { handleData(); } }}
                                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'projects', commonFilter.projects, () => {
                                      setCommonFilter({ ...commonFilter, projects: [], isChange: true });
                                  })}
                                  className="sk-input-dd w-100"
                              />
                              <MultiSelect
                                  options={projectWiseData?.sprint}
                                  optionLabel="sprint_name"
                                  optionValue="sprint_id"
                                  placeholder="Sprint"
                                  value={commonFilter?.sprint}
                                  filter
                                  onChange={(e) => { setCommonFilter({ ...commonFilter, sprint: e.value, isChange: true }); }}
                                  onHide={() => { if (commonFilter?.isChange) { getPlanningDetails() } }}
                                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'sprint', commonFilter.sprint, () => setCommonFilter({ ...commonFilter, sprint: [], isChange: true }))}
                                  className="sk-input-dd w-100"
                              />
                              <MultiSelect
                                  options={projectWiseData?.issueType}
                                  optionLabel="issue_type_name"
                                  optionValue="issue_type_id"
                                  placeholder="Task Type"
                                  value={commonFilter?.issueType}
                                  filter
                                  onChange={(e) => { setCommonFilter({ ...commonFilter, issueType: e.value, isChange: true }); }}
                                  onHide={() => { if (commonFilter?.isChange) { getPlanningDetails(null) } }}
                                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'issueType', commonFilter.issueType, () => setCommonFilter({ ...commonFilter, issueType: [], isChange: true }))}
                                  className="sk-input-dd w-100"
                              />
                              <MultiSelect
                                  options={projectWiseData?.subProject}
                                  optionLabel="project_module_name"
                                  optionValue="option_id"
                                  placeholder="Sub Project"
                                  value={commonFilter?.subProject}
                                  filter
                                  onChange={(e) => { setCommonFilter({ ...commonFilter, subProject: e.value, isChange: true }); }}
                                  onHide={() => { if (commonFilter?.isChange) { getPlanningDetails(); } }}
                                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'subProject', commonFilter.subProject, () => setCommonFilter({ ...commonFilter, subProject: [], isChange: true }))}
                                  className="sk-input-dd w-100"
                              />
                              <MultiSelect
                                  options={projectWiseData?.reporters}
                                  optionLabel="user_display_name"
                                  optionValue="reporter_user_code"
                                  placeholder="Reporters"
                                  value={commonFilter?.reporters}
                                  filter
                                  onChange={(e) => { setCommonFilter({ ...commonFilter, reporters: e.value, isChange: true }); }}
                                  onHide={() => { if (commonFilter?.isChange) { getPlanningDetails(); } }}
                                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'reporters', commonFilter.reporters, () => setCommonFilter({ ...commonFilter, reporters: [], isChange: true }))}
                                  className="sk-input-dd w-100"
                              />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="sk-drawer-footer">
                  <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                      getPlanningDetails();
                      setShowFiltersDrawer(false);
                  }}>Apply Filters</button>
              </div>
          </div>
      </div>
    </div >
  );
}

export default Planning;
